import agency from './agency';
import appearance from './appearance';
import comment from './comment';
import dashboard from './dashboard';
import feedback from './feedback';
import kiotviet from './kiotviet';
import language from './language';
import media from './media';
import postType from './postType';
import posts from './posts';
import rating from './rating';
import seo from './seo';
import settings from './settings';
import shipping from './shipping';
import user from './user';
import warehouse from './warehouse';
import widget from './widget';

export default {
  ...agency,
  ...appearance,
  ...comment,
  ...dashboard,
  ...feedback,
  ...language,
  ...media,
  ...postType,
  ...posts,
  ...rating,
  ...seo,
  ...settings,
  ...shipping,
  ...user,
  ...warehouse,
  ...widget,
  ...kiotviet,
};
